var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.width ? _c('div', {
    style: {
      width: _vm.width + 'px',
      height: 7 * _vm.width / 5 + 'px'
    }
  }, [_c('div', {
    staticClass: "card-preview-page",
    class: {
      editable: _vm.editable,
      'overflow-hidden': !_vm.allowOverflow
    },
    style: {
      transform: `scale(${_vm.width / 600})`,
      'background-image': _vm.card.background.img ? `url('${_vm.card.background.img}')` : null,
      'background-color': _vm.card.background.color
    }
  }, _vm._l(_vm.blobs, function (blob) {
    return _c('blob', {
      key: blob.id,
      ref: blob.id,
      refInFor: true,
      class: 'blob--' + blob.id,
      attrs: {
        "mode": _vm.mode,
        "is-page-active": _vm.editable,
        "scale": 1,
        "blob": blob,
        "skin": _vm.card.skin || {},
        "is-primary": blob.user_id && blob.user_id == _vm.globalUserId,
        "is-card-owner": _vm.isCardOwner,
        "is-verified-recipient": _vm.isVerifiedRecipient,
        "static": _vm.static
      },
      on: {
        "loaded": function ($event) {
          return _vm.loadedIds.push(blob.id);
        },
        "input": function (x) {
          return _vm.$emit('update-blob', x);
        }
      }
    });
  }), 1)]) : _c('auto-width', {
    staticStyle: {
      "aspect-ratio": "5 / 7"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (slot) {
        return [slot.width ? _c('card-preview', _vm._g(_vm._b({
          attrs: {
            "width": slot.width
          }
        }, 'card-preview', _vm.$props, false), _vm.$listeners)) : _vm._e()];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }